type ExtractExistingKeys<R extends Record<string, any>, Keys extends keyof R> = Pick<
  R,
  {
    [K in Keys]: R[K] extends undefined | null ? never : K;
  }[Keys]
>;

export const pickExistingKeys = <
  R extends Record<string | number, any>,
  KeysArr extends Array<keyof R>,
>(
  record: R,
  keys: Array<keyof R>,
) =>
  keys.reduce(
    (acc, key) =>
      record[key] === undefined || record[key] === null ? acc : { ...acc, [key]: record[key] },
    {},
  ) as ExtractExistingKeys<R, KeysArr[number]>;

export const excludeKeys = <R extends Record<string, any>, Keys extends keyof R>(
  record: R,
  keys: Keys[],
): Omit<R, Keys> =>
  keys.reduce(
    (acc, key) => {
      delete acc[key];

      return acc;
    },
    { ...record },
  );
